// src/services/propFirmApi.js

import api from "@/lib/api";

export const createPropFirm = async (formData) => {
    const res = await api.post("/prop-firms", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });

    return res.data;
};

export const getPropFirmById=async()=>{
    try {
        const res=await api.get(`/prop-firms/${firm_id}`)
        console.log(res)
    } catch (error) {
        console.log(error)
    }
}

export const deletePropFirms=async({firm_id})=>{
    try {
        const res=await api.delete(`/prop-firms/${firm_id}`)
        console.log("firm is deleted",res)
    } catch (error) {
     console.log(error)   
    }
}